import React from "react";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

import MenuLink from "../MenuLink";

/* eslint-disable react/forbid-prop-types, @typescript-eslint/no-empty-function */
import css from "./NavMenuLevel.module.scss";

/*
 * Menu structure:
 * 1st level: Exhibition Guides & Podcasts.
 * 2nd level of Exhibition Guides: Non-linking headers.
 * Paintings from the Collection, Featured Exhibitions, Past Exhibitions.
 * 3rd level of Exhibition Guides: Each individual guide.
 * 4th level of Exhibition Guides: Guide subpages (map, speakers, etc).
 */

const TITLE_STYLE_MAP = {
  "/paintings": [css.sectionTitle, css.galleryTitle],
  "/kids-audio-guide": [css.sectionTitle, css.kidsTitle],
  "/map-rooms": [css.sectionTitle, css.mapRoomsTitle],
  "/maps-pacific": [css.sectionTitle, css.mapsPacificTitle],
  "/maps-of-the-pacific": [css.sectionTitle, css.mapsPacificTitle],
  "/imaginethe-wonder-picture-books": [css.sectionTitle, css.mapsImagineExhib],
  "/pride-revolution": [css.sectionTitle, css.mapsPrideRevolution],
  '/objects-gallery': [css.sectionTitle, css.mapsObjectsGallery],
};

const FOOTER_STYLE_MAP = {
  "/paintings": [],
  "/kids-audio-guide": [css.kidsSectionFooter],
  "/map-rooms": [],
  "/maps-pacific": [],
  "/maps-of-the-pacific": []
};

const NavMenuLevel = ({
  items = [],
  depth = 0,
  prefixItems = [],
  drupalSettings = {},
  closeMenu = () => {}
}) => {
  if (!items || !items.length) {
    return [];
  }

  if (depth === 0) {
    return (
      <>
        {prefixItems.concat(items).map(item => (
          <React.Fragment key={item.key}>
            <MenuLink
              item={item}
              depth={depth}
              drupalSettings={drupalSettings}
              onClick={closeMenu}
            />
            {item.expanded &&
              prefixItems.indexOf(item) < 0 &&
              (item.below || []).length > 0 && (
                <NavMenuLevel
                  items={item.below}
                  drupalSettings={drupalSettings}
                  depth={depth + 1}
                  closeMenu={closeMenu}
                />
              )}
          </React.Fragment>
        ))}
      </>
    );
  }

  if (depth === 1) {
    return (
      <>
        {prefixItems.concat(items).map(item => (
          <React.Fragment key={item.key}>
            <MenuLink
              item={item}
              depth={depth}
              drupalSettings={drupalSettings}
              onClick={closeMenu}
            />
            {item.expanded &&
              prefixItems.indexOf(item) < 0 &&
              (item.below || []).length > 0 && (
                <NavMenuLevel
                  items={item.below}
                  drupalSettings={drupalSettings}
                  depth={depth + 1}
                  closeMenu={closeMenu}
                />
              )}
          </React.Fragment>
        ))}
      </>
    );
  }

  if (depth === 2) {
    return (
      <>
        {prefixItems.concat(items).map(item => (
          <React.Fragment key={item.key}>
            {prefixItems.indexOf(item) < 0 && (
              <>
                {!item.expanded && (
                  <MenuLink
                    item={item}
                    depth={depth}
                    drupalSettings={drupalSettings}
                    className={(TITLE_STYLE_MAP[item.relative] || []).join(" ")}
                    onClick={closeMenu}
                  />
                )}
                {item.expanded && (
                  <Accordion>
                    <Card className={css.menuContainer}>
                      <Accordion.Toggle
                        as={Card.Header}
                        variant="link"
                        eventKey="0"
                      >
                        <h4
                          className={[]
                            .concat(TITLE_STYLE_MAP[item.relative] || [])
                            .join(" ")}
                        >
                          {item.title}
                        </h4>
                      </Accordion.Toggle>

                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          <div className={css.menuBody}>
                            <NavMenuLevel
                              items={item.below}
                              drupalSettings={drupalSettings}
                              depth={depth + 1}
                              prefixItems={[
                                {
                                  ...item,
                                  title: "Captions & Audio Guides",
                                  below: []
                                }
                              ]}
                              closeMenu={closeMenu}
                            />
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <div
                      className={[css.sectionFooter]
                        .concat(FOOTER_STYLE_MAP[item.relative] || [])
                        .join(" ")}
                    />
                  </Accordion>
                )}
              </>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }

  return (
    <ul>
      {prefixItems.concat(items).map(item => (
        <li key={item.key}>
          <MenuLink
            item={item}
            depth={depth}
            drupalSettings={drupalSettings}
            onClick={closeMenu}
          />
          {item.expanded &&
            prefixItems.indexOf(item) < 0 &&
            (item.below || []).length > 0 && (
              <NavMenuLevel
                items={item.below}
                drupalSettings={drupalSettings}
                depth={depth + 1}
                closeMenu={closeMenu}
              />
            )}
        </li>
      ))}
    </ul>
  );
};

NavMenuLevel.propTypes = {
  items: PropTypes.array.isRequired,
  depth: PropTypes.number,
  prefixItems: PropTypes.array,
  drupalSettings: PropTypes.any,
  closeMenu: PropTypes.func
};

NavMenuLevel.defaultProps = {
  depth: 0,
  prefixItems: [],
  drupalSettings: {},
  closeMenu: () => {}
};

export default NavMenuLevel;
